/**
 * This is the service which encapsulates all the http methods
 */
var GenericServiceAjs = /** @class */ (function () {
    /*@ngInject*/
    function GenericServiceAjs($q, $http) {
        this.$q = $q;
        this.$http = $http;
    }
    /**
     * This method is to perform any pre processing of error on request.
     * @param promise of the request to be cancelled
     */
    GenericServiceAjs.prototype._handleError = function (error) {
        if (!_.isUndefined(error.developerMsg) && !_.isNull(error.developerMsg) && error.developerMsg != '') {
            error.message = error.developerMsg;
        }
        return error;
    };
    /**
     * This method allows the users to cancel a request by passing in the promise of that request.
     * @param promise of the request to be cancelled
     */
    GenericServiceAjs.prototype.cancelRequest = function (promise) {
        // If the promise does not contain a hook into the deferred timeout,
        // the simply ignore the cancel request.
        if (promise && promise._httpTimeout && promise._httpTimeout.resolve) {
            promise._httpTimeout.resolve('user cancellation');
        }
    };
    ;
    /**
     * This will allow to add object to DB by calling the api using http POST method.
     * @param url at which api is mapped
     * @param object to be added
     */
    GenericServiceAjs.prototype.addObject = function (url, object, additionalParams) {
        var _this = this;
        var deferred = this.$q.defer();
        var requestObject = {
            method: 'POST',
            url: url,
            data: object,
            timeout: deferred.promise
        };
        if (!_.isUndefined(additionalParams) && typeof additionalParams == 'object') {
            angular.forEach(additionalParams, function (val, key) {
                requestObject[key] = val;
            });
        }
        this.$http(requestObject).then(function (response) {
            // this callback will be called asynchronously
            // when the response is available
            if (response.status == '200') {
                deferred.resolve(response.data);
            }
            else {
                response.data = _this._handleError(response.data);
                deferred.reject(response.data);
            }
        }, function (response) {
            // called asynchronously if an error occurs
            // or server returns response with an error status.
            if (response.status != -1) {
                response.data = _this._handleError(response.data);
            }
            else {
                // request has been explicitly cancelled.
                response.data = {
                    message: 'user cancellation'
                };
            }
            deferred.reject(response.data);
        });
        // Store the deferred timeout on the promise so that our .cancel()
        // method can access it later, if necessary.
        deferred.promise._httpTimeout = deferred;
        return deferred.promise;
    };
    /**
     * This will allow to update the object by calling api using http PUT method
     * @param url at which api is mapped
     * @param object to be updated
     */
    GenericServiceAjs.prototype.putObject = function (url, object) {
        var _this = this;
        var deferred = this.$q.defer();
        this.$http({
            method: "PUT",
            url: url,
            data: object,
            timeout: deferred.promise
        }).then(function (response) {
            // this callback will be called asynchronously
            // when the response is available
            if (response.status == '200') {
                deferred.resolve(response.data);
            }
            else {
                response.data = _this._handleError(response.data);
                deferred.reject(response.data);
            }
        }, function (response) {
            // called asynchronously if an error occurs
            // or server returns response with an error status.
            if (response.status != -1) {
                response.data = _this._handleError(response.data);
            }
            else {
                // request has been explicitly cancelled.
                response.data = {
                    message: 'user cancellation'
                };
            }
            deferred.reject(response.data);
        });
        return deferred.promise;
    };
    /**
     * This will allow to get object by id, id of the object to be
     * fetched should be appended to the url.
     * @param url of the api with appended id.
     */
    GenericServiceAjs.prototype.getObjectById = function (url) {
        var _this = this;
        var deferred = this.$q.defer();
        this.$http({
            method: "GET",
            url: url,
            timeout: deferred.promise
        }).then(function (response) {
            // this callback will be called asynchronously
            // when the response is available
            if (response.status == '200') {
                deferred.resolve(response.data);
            }
            else {
                response.data = _this._handleError(response.data);
                deferred.reject(response.data);
            }
        }, function (response) {
            // called asynchronously if an error occurs
            // or server returns response with an error status.
            if (response.status != -1) {
                response.data = _this._handleError(response.data);
            }
            else {
                // request has been explicitly cancelled.
                response.data = {
                    message: 'user cancellation'
                };
            }
            deferred.reject(response.data);
        });
        // Store the deferred timeout on the promise so that our .cancel()
        // method can access it later, if necessary.
        deferred.promise._httpTimeout = deferred;
        return deferred.promise;
    };
    /**
     * This will allow to get all objects by calling backend API,
     * using http GET method,
     * @param url of api to be invoked
     */
    GenericServiceAjs.prototype.getObjects = function (url, additionalParams) {
        var _this = this;
        var deferred = this.$q.defer();
        var requestObject = {
            method: "GET",
            url: url,
            timeout: deferred.promise
        };
        if (!_.isUndefined(additionalParams) && typeof additionalParams == 'object') {
            angular.forEach(additionalParams, function (val, key) {
                requestObject[key] = val;
            });
        }
        this.$http(requestObject).then(function (response) {
            // this callback will be called asynchronously
            // when the response is available
            if (response.status == '200') {
                deferred.resolve(response.data);
            }
            else {
                response.data = _this._handleError(response.data);
                deferred.reject(response.data);
            }
        }, function (response) {
            // called asynchronously if an error occurs
            // or server returns response with an error status.
            if (response.status != -1) {
                response.data = _this._handleError(response.data);
            }
            else {
                // request has been explicitly cancelled.
                response.data = {
                    message: 'user cancellation'
                };
            }
            deferred.reject(response.data);
        });
        // Store the deferred timeout on the promise so that our .cancel()
        // method can access it later, if necessary.
        deferred.promise._httpTimeout = deferred;
        return deferred.promise;
    };
    /**
     * This will allow to delete object by calling api using http DELETE method
     * @param url at which api is mapped
     * @param object to be deleted
     */
    GenericServiceAjs.prototype.deleteObject = function (url, object) {
        var _this = this;
        var deferred = this.$q.defer();
        this.$http({
            method: "DELETE",
            url: url,
            data: object,
            headers: { 'Content-Type': 'application/json' },
            timeout: deferred.promise
        }).then(function (response) {
            // this callback will be called asynchronously
            // when the response is available
            if (response.status == '200') {
                deferred.resolve(response.data);
            }
            else {
                response.data = _this._handleError(response.data);
                deferred.reject(response.data);
            }
        }, function (response) {
            // called asynchronously if an error occurs
            // or server returns response with an error status.
            if (response.status != -1) {
                response.data = _this._handleError(response.data);
            }
            else {
                // request has been explicitly cancelled.
                response.data = {
                    message: 'user cancellation'
                };
            }
            deferred.reject(response.data);
        });
        return deferred.promise;
    };
    /**
     * This will allow to upload file by calling the api.
     * @param url at which api is mapped
     * @param object file object to be uploaded
     */
    GenericServiceAjs.prototype.uploadFile = function (url, object) {
        var _this = this;
        var deferred = this.$q.defer();
        this.$http({
            method: "POST",
            url: url,
            data: object,
            headers: { 'Content-Type': undefined },
            transformRequest: angular.identity,
            timeout: deferred.promise
        }).then(function (response) {
            // this callback will be called asynchronously
            // when the response is available
            if (response.status == '200') {
                deferred.resolve(response.data);
            }
            else {
                response.data = _this._handleError(response.data);
                deferred.reject(response.data);
            }
        }, function (response) {
            // called asynchronously if an error occurs
            // or server returns response with an error status.
            if (response.status != -1) {
                response.data = _this._handleError(response.data);
            }
            else {
                // request has been explicitly cancelled.
                response.data = {
                    message: 'user cancellation'
                };
            }
            deferred.reject(response.data);
        });
        return deferred.promise;
    };
    return GenericServiceAjs;
}());
export { GenericServiceAjs };
//# sourceMappingURL=genericServiceAjs.js.map